module.exports = __webpack_public_path__ + "img/case9.6c75b520.png";